import { shallowMount } from '@vue/test-utils';
import NotificationBannerCms from '../index.vue';
import testCaseWrapper from '~/helpers/test/testCaseWrapper';

function createWrapper(propsData) {
  return shallowMount(NotificationBannerCms, {
    propsData,
  });
}

const mockMessage = 'mock message';

const testCasesForSnapshots = [
  {
    condition: 'When no message and no hideBanner info is provided',
    assertion: 'it does not show banner',
    data: {},
  },
  {
    condition: 'When a message is provided but hideBanner is also selected',
    assertion: 'it does not show banner',
    data: {
      message: mockMessage,
      hideBanner: true,
    },
  },
  {
    condition: 'When a message is provided and no hideBanner info is provided',
    assertion: 'it shows the banner',
    data: {
      message: mockMessage,
    },
  },
];

testCaseWrapper(
  'NotificationBannerCms.vue',
  createWrapper,
  testCasesForSnapshots,
);
